import { isReactSnap, pageLoaded } from '../../utils';

const getSDK = () => import('@braze/web-sdk');

type InitializationState = 'notStarted' | 'inProgress' | 'complete' | 'falure';

class BrazeService {
  private readonly API_KEY = '4e378eca-1d2e-415c-bf3c-6ddc8a5c9022';

  private _SDK: undefined | ReturnType<typeof getSDK>;

  private get SDK() {
    if (!this._SDK) {
      this._SDK = pageLoaded(this.fetchTimeout).then(getSDK);
    }

    return this._SDK;
  }

  public initialisationState: InitializationState = 'notStarted';

  constructor(
    private appName: string,
    protected options: { baseUrl: string },
    protected isDevelopment: boolean,
    protected fetchTimeout = 3000,
  ) {}

  public async init() {
    if (
      !this.isDevelopment &&
      !isReactSnap() &&
      !!window &&
      this.initialisationState !== 'complete'
    ) {
      const { initialize, subscribeToInAppMessage, showInAppMessage } = await this.SDK;

      const isInitialised = initialize(this.API_KEY, {
        ...this.options,
        allowUserSuppliedJavascript: true,
      });

      this.initialisationState = isInitialised ? 'complete' : 'falure';

      if (isInitialised) {
        subscribeToInAppMessage(function (inAppMessage) {
          showInAppMessage(inAppMessage);
        });
      }
    }

    if (this.initialisationState === 'complete') {
      const { openSession } = await this.SDK;
      openSession();
    }
  }

  public async event(name: string, params: object = {}) {
    if (this.initialisationState !== 'notStarted') {
      const { logCustomEvent } = await this.SDK;
      if (this.initialisationState === 'complete') {
        logCustomEvent(`qt_${this.appName}_${name}`, { ...params });
      }
    }
  }
}

export default BrazeService;
